export var FeatureBudgetType;
(function (FeatureBudgetType) {
    FeatureBudgetType["ColdTier"] = "ColdTier";
    FeatureBudgetType["Metrics"] = "Metrics";
    FeatureBudgetType["Siem"] = "Siem";
    FeatureBudgetType["Timeless"] = "Timeless";
})(FeatureBudgetType || (FeatureBudgetType = {}));
//# sourceMappingURL=feature-budget-type.enum.js.map